import { IHooksUseRequestVerifyPhotosParams } from '@/interfaces';
import { broadcastService, storageService } from '@/services';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestVerifyPhotosParams;
type TResponseData = void;

export const useRequestVerifyPhotos = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.verifications.photo, 'verify'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.verifications.photo, data)
        .then(handleApiResponse)
        .then(
          () => {
            storageService
              .recentVerifications
              .add([data]);
          }
        )
        .then(() => broadcastService.events.publish({ type: 'photosVerified', data })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.verifications.completed),
          invalidate(routes.api.verifications.count),
          invalidate(routes.api.verifications.photo)
        ])
    )
  });

  const triggerVerification = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoading: isPending,
    triggerVerification,
    error
  });

};  
